module.exports = __webpack_public_path__ + "media/images/dafiti-f16009e7dfa9173e8f647b034ba9739b.svg";